<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <h4 class="color-secundary">
        Resumen de cifras con corte a: {{ fechaActualizacionMasReciente }}
      </h4>
      <br />

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component :data="data" @click-event="clickEvent" :dataLength="dataLength" :perPage="10000" pagination
        showExportToExcel>
        <table-column slot="label" :label="'Código'" showExportToExcel v-bind:value="'Codigo'"
          :customClass="'text-center'"></table-column>
        <table-column slot="label" :label="'Modelo'" v-bind:value="'Modelo'"
          :customClass="'text-center'"></table-column>
        <table-column slot="label" :label="'Producto'" v-bind:value="'Producto'"
          :customClass="'text-center'"></table-column>
        <table-column slot="label" :label="'Total Desembolsos'" v-bind:value="'Valor_Credito'" :filter="'numberFormat'"
          :customClass="'text-right'"></table-column>
        <table-column slot="label" :label="'Valor generado para reclamación'"
          v-bind:value="'Valor_Generado_Reclamacion'" :filter="'numberFormat'"
          :customClass="'text-right'"></table-column>
        <table-column slot="label" :label="'Cartera'" v-bind:value="'Cartera'" :filter="'numberFormat'"
          :customClass="'text-right'"></table-column>
        <table-column slot="label" :label="'Saldo total'" v-bind:value="'Saldo_Total'" :filter="'numberFormat'"
          :customClass="'text-right'"></table-column>
        <table-column slot="label" :label="'Total Pagado'" v-bind:value="'Total_Pagado'" :filter="'numberFormat'"
          :customClass="'text-right'"></table-column>
        <table-column slot="label" :label="'Otros pagos'" v-bind:value="'Otros_Pagos'" :filter="'numberFormat'"
          :customClass="'text-right'"></table-column>
        <table-column slot="label" :label="'Saldo para reclamación'" v-bind:value="'Saldo_Para_Reclamacion'"
          :filter="'numberFormat'" :customClass="'text-right'"></table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      fechaCorte: "",
      fechaActualizacionMasReciente: "",
      data: [],
      dataLength: 0,
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
      loading: "loading",
    }),
    rows() {
      return this.TablaEstadoProceso.length;
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    formatearFecha(iso) {
      if (!iso) return "";
      return this.$moment.utc(iso).format("YYYY-MM-DD HH:mm");
    },
    clickEvent(event, slug) {
      this.$store.commit("SET_LOADING", true);
      switch (slug) {
        case "export-to-excel":
          this.$toasted.show("Por favor espere mientras exportamos los datos", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 5000,
          });
          try {
            let info_to_export = Array();

            this.data.forEach((element) => {
              info_to_export.push({
                Codigo: element.Codigo,
                Modelo: element.Modelo,
                Producto: element.Producto,
                Valor_Credito: element.Valor_Credito,
                Valor_Generado_Reclamacion: element.Valor_Generado_Reclamacion,
                Cartera: element.Cartera,
                Saldo_Total: element.Saldo_Total,
                Total_Pagado: element.Total_Pagado,
                Otros_Pagos: element.Otros_Pagos,
                Saldo_Para_Reclamacion: element.Saldo_Para_Reclamacion,
              });
            });

            let data = XLSX.utils.json_to_sheet(info_to_export, {
              header: [
                "Codigo",
                "Modelo",
                "Producto",
                "Valor_Credito",
                "Valor_Generado_Reclamacion",
                "Cartera",
                "Saldo_Total",
                "Total_Pagado",
                "Otros_Pagos",
                "Saldo_Para_Reclamacion",
              ],
            });
            data["A1"].v = "Código";
            data["B1"].v = "Modelo";
            data["C1"].v = "Producto";
            data["D1"].v = "Valor crédito";
            data["E1"].v = "Valor generado para reclamación";
            data["F1"].v = "Cartera";
            data["G1"].v = "Saldo total";
            data["H1"].v = "Total Pagado";
            data["I1"].v = "Otros agos";
            data["J1"].v = "Saldo para Reclamación";

            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, data, "Resumen Cifras");
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              "ResumenCifras.xlsx"
            );
          } catch (err) {
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          break;
      }
      this.$store.commit("SET_LOADING", false);
    },
    async dataProcesada() {
      this.$store.commit("SET_LOADING", true);
      try {
        let response = await this.$store.state.api.get(
          "informes/resumen_cifras_2",
          { params: { paginar: false } }
        );
        let dataProcesada = [];

        let data = response.data.datos.filter(
          (e) =>
            e.Valor_Credito != 0 ||
            e.Valor_Generado_Reclamacion != 0 ||
            e.Cartera != 0 ||
            e.Saldo_Total != 0 ||
            e.Total_Pagado != 0 ||
            e.Otros_Pagos != 0 ||
            e.Saldo_Para_Reclamacion != 0
        );

        let convenios = [];
        let fechaMasRecienteMs = null;
        let fechaMasRecienteIso = null;

        // listamos distint convenio
        data.forEach((e) => {
          if (convenios.indexOf(e.Codigo) == -1) {
            convenios[e.Codigo] = e.Codigo;
          }
          const iso = e.fecha_actualizacion;
          const ms = iso ? Date.parse(iso) : NaN;
          if (!Number.isNaN(ms) && (fechaMasRecienteMs === null || ms > fechaMasRecienteMs)) {
            fechaMasRecienteMs = ms;
            fechaMasRecienteIso = iso;
          }
          // e.fecha_actualizacion = this.formatearFecha(iso);
        });

        // fecha más actualizada de fecha_actualizacion (formato YYYY-MM-DD HH:mm)
        this.fechaActualizacionMasReciente = fechaMasRecienteIso
          ? this.formatearFecha(fechaMasRecienteIso)
          : "";
        console.log(data);
        console.log(convenios);

        convenios.forEach((element) => {
          let infoConvenios = data.filter((e) => e.Codigo == element);

          let totales_convenios = {
            Producto: "Total por convenio:",
            Saldo_Para_Reclamacion: infoConvenios.reduce(
              (a, b) => parseInt(a) + b.Saldo_Para_Reclamacion,
              0
            ),
            Valor_Credito: infoConvenios.reduce(
              (a, b) => parseInt(a) + parseInt(b.Valor_Credito),
              0
            ),
            Total_Pagado: infoConvenios.reduce((a, b) => {
              const valorA = parseInt(a) || 0;
              const valorB = parseInt(b.Total_Pagado) || 0;
              return valorA + valorB;
            }, 0),
            Otros_Pagos: infoConvenios.reduce(
              (a, b) => parseInt(a) + parseInt(b.Otros_Pagos),
              0
            ),
            Valor_Generado_Reclamacion: infoConvenios.reduce(
              (a, b) => parseInt(a) + b.Valor_Generado_Reclamacion,
              0
            ),
            Cartera: infoConvenios.reduce(
              (a, b) => parseInt(a) + parseInt(b.Cartera),
              0
            ),
            Saldo_Total: infoConvenios.reduce(
              (a, b) => parseInt(a) + parseInt(b.Saldo_Total),
              0
            ),
            primary: true,
          };

          dataProcesada = dataProcesada.concat(infoConvenios);
          dataProcesada.push(totales_convenios);
        });

        this.data = dataProcesada;
        this.dataLength = dataProcesada.length;
        this.$store.commit("SET_LOADING", false);
        return true;
      } catch (err) {
        this.$toasted.show(
          "Lo sentimos, ocurrió un error al intentar consultar los datos",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000,
          }
        );
        return false;
      }
    },
  },
  mounted() {
    this.dataProcesada();
    // this.fechaCorte = this.$moment().format("YYYY-MM-DD");
    // this.fechaActualizacionMasReciente = this.formatearFecha("2026-05-27T15:07:58.672Z")
  },
};
</script>